import { useEffect, useState } from 'react';
import { css } from '@emotion/core';
import { Img } from '../../display/Img';
import { Animation, Colors, Typography } from '../../../theme';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
const getNameInitials = (name) => {
    const initials = (name || '')
        .trim()
        .split(/\s+/)
        .map((s) => s[0]);
    const firstLetter = initials[0];
    const lastLetter = initials[initials.length - 1];
    if (!firstLetter) {
        return '';
    }
    return initials.length === 1
        ? String(firstLetter)
        : `${firstLetter}${lastLetter}`;
};
const mapV4ColortoV5Color = (color) => {
    let transformedColor;
    switch (color) {
        case 'lava':
            transformedColor = 'primary';
            break;
        case 'ocean':
            transformedColor = 'secondary';
            break;
        case 'sun':
            transformedColor = 'tertiary';
            break;
        default:
            transformedColor = color;
    }
    return transformedColor;
};
const Styles = labelStyles('Avatar', {
    root: (hasError, props) => [
        css `
      ${Typography.base};
      font-weight: 700;
      line-height: 1;
      user-select: none;
      align-items: center;
      border-radius: 50%;
      display: inline-flex;
      justify-content: center;
      overflow: hidden;
      position: relative;
      border: 1px solid ${Colors.neutral100};
      transition: ${Animation.transitionValue};

      &[data-block] {
        display: flex;
      }

      &[data-interactive] {
        &:hover,
        &:focus {
          border-color: ${Colors.neutral300};
        }
      }

      &[data-selected][data-selected] {
        border-color: ${Colors.blue};
      }
    `,
        !props.url || (props.url && hasError)
            ? css `
          &:nth-of-type(1n),
          &[data-color='lava'][data-color] {
            background-color: ${Colors.neutral800};
            color: ${Colors.neutral100};
          }
          &:nth-of-type(1n),
          &[data-color='primary'][data-color] {
            background-color: ${Colors.neutral800};
            color: ${Colors.neutral100};
          }

          &:nth-of-type(2n),
          &[data-color='ocean'][data-color] {
            background-color: ${Colors.night};
            color: ${Colors.neutral100};
          }
          &:nth-of-type(2n),
          &[data-color='secondary'][data-color] {
            background-color: ${Colors.night};
            color: ${Colors.neutral100};
          }

          &:nth-of-type(3n),
          &[data-color='sun'][data-color] {
            background-color: ${Colors.moss};
            color: ${Colors.neutral100};
          }
          &:nth-of-type(3n),
          &[data-color='tertiary'][data-color] {
            background-color: ${Colors.moss};
            color: ${Colors.neutral100};
          }
        `
            : null,
        css `
      label: -${props.size}x ${props.size};
      height: ${props.size}px;
      width: ${props.size}px;
      font-size: ${Math.floor(props.size * (props.size > 25 ? 0.35 : 0.45))}px;
    `,
        props.size >= 40 &&
            css `
        border-width: 2px;
      `,
    ],
    img: css `
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  `,
});
export const Avatar = (props) => {
    const [hasError, setHasError] = useState(false);
    const { name, url, size } = props;
    const initials = name ? getNameInitials(name) : null;
    useEffect(() => {
        if (hasError) {
            setHasError(false);
        }
    }, [props.url]);
    return (isolateComponent("div", { "aria-hidden": props.ariaHidden, "aria-label": name, css: Styles.root(hasError, props), "data-block": props.isBlock ? 'true' : undefined, "data-color": mapV4ColortoV5Color(props.color), "data-interactive": props.isInteractive ? 'true' : undefined, "data-selected": props.isSelected ? 'true' : undefined, "data-size": props.size, "data-testid": "Avatar", role: "img" }, url && !hasError ? (isolateComponent(Img, { css: Styles.img, alt: name, ariaHidden: true, height: size, onError: () => setHasError(true), src: url, width: size, loading: props.shouldLazilyLoad ? 'lazy' : 'eager' })) : (isolateComponent("span", null, initials))));
};
Avatar.defaultProps = {
    shouldLazilyLoad: true,
    size: 25,
};
//# sourceMappingURL=Avatar.js.map
// @zapier/design-system@5.6.0 (4902ab0c1)
